// extracted by mini-css-extract-plugin
module.exports = {"section":"Comments_section__3bJJg","h1":"Comments_h1__2lkY0"};